import { render, staticRenderFns } from "./sync-console-page.vue?vue&type=template&id=58bfbfd1&scoped=true&"
import script from "./sync-console-page.vue?vue&type=script&lang=ts&"
export * from "./sync-console-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bfbfd1",
  null
  
)

export default component.exports